import React from 'react';
import { useQuery } from '@apollo/client';
import {
  PartnerSearchContext,
  FetchCloudSitesInPpcQuery,
  FetchCloudSitesInPpcQueryVariables,
  CloudSiteData,
} from '@css-xp/graphtypes/src/generated-types-new';
import { SiteUrlTable } from '@css-xp/ppc-site-url-table';
import { fetchCloudSitesInPPC } from '../../queries/fetch-cloud-sites';

interface SiteUrlSearchProps {
  query: string;
  transactionAccountId: string;
  partnerSearchContext: string;
  isDesignIteration1Enabled?: boolean;
}

export const SiteUrlSearch = ({
  query,
  transactionAccountId,
  partnerSearchContext,
  isDesignIteration1Enabled,
}: SiteUrlSearchProps) => {
  const { data, error, loading } = useQuery<FetchCloudSitesInPpcQuery, FetchCloudSitesInPpcQueryVariables>(
    fetchCloudSitesInPPC,
    {
      variables: {
        searchParams: {
          query,
          transactionAccountId,
          partnerSearchContext: partnerSearchContext as PartnerSearchContext,
          isOrgSearchEnabled: true,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    }
  );

  const results = (data?.partnerCloudSites?.nodes || []) as CloudSiteData[];

  return (
    <div data-testid="site-url-list">
      {
        <SiteUrlTable
          cloudSites={results}
          transactionAccountId={transactionAccountId}
          isLoading={loading}
          error={error}
          shouldHideInnerHeading={isDesignIteration1Enabled}
          isDesignIteration1Enabled={isDesignIteration1Enabled}
        />
      }
    </div>
  );
};
